<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('stakeTerms.title') }}</h3>

            <div class="textBox">
                <p class="mt-0 text-center">{{ $t('stakeTerms.version') }}</p>

                <!-- article - 1 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article1.title') }}</p>
                <p>{{ $t('stakeTerms.article1.text1') }}</p>
                <p v-html="$t('stakeTerms.article1.text2')"></p>
                <p>{{ $t('stakeTerms.article1.text3') }}</p>
                <p>{{ $t('stakeTerms.article1.text4') }}</p>
                <p>{{ $t('stakeTerms.article1.text5') }}</p>

                <!-- article - 2 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article2.title') }}</p>
                <p>{{ $t('stakeTerms.article2.text1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article2.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article2.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article2.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article2.point4') }}</p>

                <!-- article - 3 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article3.title') }}</p>
                <p>{{ $t('stakeTerms.article3.text1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article3.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article3.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article3.point3') }}</p>
                <p v-html="$t('stakeTerms.article3.text2')"></p>

                <!-- article - 4 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article4.title') }}</p>
                <p>{{ $t('stakeTerms.article4.text1') }}</p>
                <p>{{ $t('stakeTerms.article4.text2') }}</p>

                <!-- article - 5 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article5.title') }}</p>
                <p>{{ $t('stakeTerms.article5.text1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point4') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point5') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point6') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point7') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point8') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point9') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article5.point10') }}</p>

                <!-- article - 6 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article6.title') }}</p>
                <p>{{ $t('stakeTerms.article6.text1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article6.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article6.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article6.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article6.point4') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article6.point5') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article6.point6') }}</p>

                <!-- article - 7 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article7.title') }}</p>
                <p>{{ $t('stakeTerms.article7.text1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article7.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article7.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article7.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article7.point4') }}</p>
                <p>{{ $t('stakeTerms.article7.text2') }}</p>
                <p>{{ $t('stakeTerms.article7.text3') }}</p>
                <p>{{ $t('stakeTerms.article7.text4') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article7.point5') }}</p>
                <p class="p-0 pl-4 num">{{ $t('stakeTerms.article7.point6') }}</p>

                <!-- article - 8 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article8.title') }}</p>
                <p>{{ $t('stakeTerms.article8.text1') }}</p>
                <p>{{ $t('stakeTerms.article8.text2') }}</p>
                <p>{{ $t('stakeTerms.article8.text3') }}</p>

                <!-- article - 9 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article9.title') }}</p>
                <p>{{ $t('stakeTerms.article9.text1') }}</p>
                <p>{{ $t('stakeTerms.article9.text2') }}</p>

                <!-- article - 10 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article10.title') }}</p>
                <p>{{ $t('stakeTerms.article10.text1') }}</p>
                <p v-html="$t('stakeTerms.article10.text2')"></p>

                <!-- article - 11 -->
                <p class="mt-4 font-weight-bold">{{ $t('stakeTerms.article11.title') }}</p>
                <p>{{ $t('stakeTerms.article11.text1') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'aubeStakeTerms',

        components: {
        },

        mounted() {
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 991px) {
        .pl-4, .px-4 {
            padding-left: 1rem !important;
        }
    }
</style>
